<template>
  <section class="pmp-card">
    <div class="pmp-section-head">
      <h1 class="pmp-section-title">Producto y color</h1>
    </div>

    <PMPDropdown
      v-model="localForm.producto"
      label="Producto"
      placeholder="Selecciona producto"
      :options="productos"
      :error="errors.producto"
      error-message="Selecciona un producto."
      @select="handleProductoSelect"
    />

    <PMPDropdown
      v-model="localForm.color"
      label="Color"
      placeholder="Selecciona color"
      :options="colores"
      :error="errors.color"
      error-message="Selecciona un color."
      @select="handleColorSelect"
    />

    <PMPField
      :model-value="localForm.cantidadPigmentoGr"
      id="pmp-cantidad-pigmento-gr"
      label="Cantidad de pigmento (Gr)"
      type="text"
      inputmode="decimal"
      min="0"
      step="0.01"
      max-digits="4"
      placeholder="Ej. 250"
      :error="errors.cantidadPigmentoGr"
      error-message="Ingresa la cantidad de pigmento en gramos."
      @update:modelValue="handleCantidadPigmentoInput"
    />

    <!--
      Pregunta explícita Sí / No, sin valor por defecto: el operador debe
      elegir. El botón único anterior ("Sin aditivo" / "Con aditivo") se leía
      como una opción a seleccionar y al tocarlo se invertía el valor.
    -->
    <div class="pmp-field">
      <span id="pmp-aditivo-label" class="pmp-form-label">¿Lleva aditivo?</span>
      <div
        class="pmp-aditivo-options"
        role="radiogroup"
        aria-labelledby="pmp-aditivo-label"
      >
        <button
          v-for="opcion in opcionesAditivo"
          :key="opcion.label"
          type="button"
          class="pmp-aditivo-toggle"
          :class="{
            'is-active': localForm.aditivo === opcion.value,
            'is-error': errors.aditivo,
          }"
          role="radio"
          :aria-checked="localForm.aditivo === opcion.value"
          @click="seleccionarAditivo(opcion.value)"
        >
          <i
            class="bi"
            :class="localForm.aditivo === opcion.value ? opcion.iconoActivo : opcion.icono"
            aria-hidden="true"
          ></i>
          <span>{{ opcion.label }}</span>
        </button>
      </div>
      <p v-if="errors.aditivo" class="pmp-error-message">
        Indica si el producto lleva aditivo.
      </p>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";

import PMPField from "../components/PMPField.vue";
import PMPDropdown from "../components/PMPDropdown.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  productos: {
    type: Array,
    default: () => [],
  },
  colores: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:modelValue", "field-change"]);

const localForm = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

function handleProductoSelect(option) {
  localForm.value.productoLabel = option.label;
  localForm.value.productoCode = option.code || "";
  notifyFieldChange("producto");
}

function handleColorSelect(option) {
  localForm.value.colorLabel = option.label;
  localForm.value.colorHex = option.hex || "";
  notifyFieldChange("color");
}

const opcionesAditivo = [
  { value: true,  label: "Sí", icono: "bi-check-circle", iconoActivo: "bi-check-circle-fill" },
  { value: false, label: "No", icono: "bi-x-circle",     iconoActivo: "bi-x-circle-fill" },
];

function seleccionarAditivo(value) {
  localForm.value.aditivo = value;
  notifyFieldChange("aditivo");
}

function handleCantidadPigmentoInput(value) {
  localForm.value.cantidadPigmentoGr = value; // ← PMPField ya filtra
  notifyFieldChange("cantidadPigmentoGr");
}

function notifyFieldChange(field) {
  emit("field-change", { field });
}
</script>
